export enum ApplicationStatusType {
    Incomplete = 0,
    SubmittedByApplicant = 1,
    SubmittedForReview = 2,
    Appraise = 3,
    RecycleBin_Duplicate = 4,
    RecycleBin_MadeInError = 5,
    RecycleBin_Testing = 6,
    Lost_WithdrawnByClient = 7,
    IncompleteFile = 8,
    Lost_DeclinedByBfi = 9,
    ConvertedToLoan = 10,
    RecycleBin_Reassigned = 11,
    Incomplete_ContactedWillNotBeSubmitted = 13,
    Incomplete_CouldNotContact = 14,
}

export const ApplicationStatusTypeOptions = [
    {
        id: ApplicationStatusType.Incomplete,
        name: 'Unsubmitted',
        shortName: 'Unsubmitted',
    },
    {
        id: ApplicationStatusType.SubmittedByApplicant,
        name: 'Submitted',
        shortName: 'Submitted',
    },
    {
        id: ApplicationStatusType.SubmittedForReview,
        name: 'Ready for Review',
        shortName: 'Rdy for Rvw',
    },
    {
        id: ApplicationStatusType.Appraise,
        name: 'Appraise',
        shortName: 'Appraise',
    },
    {
        id: ApplicationStatusType.RecycleBin_Duplicate,
        name: 'Recycle Bin - Dup',
        shortName: 'Rcycl-Dup.',
    },
    {
        id: ApplicationStatusType.RecycleBin_MadeInError,
        name: 'Recycle Bin - Error',
        shortName: 'Rcycl-Err.',
    },
    {
        id: ApplicationStatusType.RecycleBin_Testing,
        name: 'Recycle Bin - Testing',
        shortName: 'Rcycl-Test.',
    },
    {
        id: ApplicationStatusType.Lost_WithdrawnByClient,
        name: 'Withdrawn by Client',
        shortName: 'Wthdrwn by Clnt',
    },
    {
        id: ApplicationStatusType.IncompleteFile,
        name: 'Incomplete File',
        shortName: 'Incmpl. File',
    },
    {
        id: ApplicationStatusType.Lost_DeclinedByBfi,
        name: 'Lost-Declined',
        shortName: 'Lost-Declnd',
    },
    {
        id: ApplicationStatusType.ConvertedToLoan,
        name: 'Converted to Loan',
        shortName: 'Cnvrtd to Ln',
    },
    {
        id: ApplicationStatusType.RecycleBin_Reassigned,
        name: 'Recycle Bin - Reassigned',
        shortName: 'Rcycl-Reas.',
    },
    {
        id: ApplicationStatusType.Incomplete_ContactedWillNotBeSubmitted,
        name: 'Contacted, Will Not Be Submitted',
        shortName: 'Incom. Contact',
    },
    {
        id: ApplicationStatusType.Incomplete_CouldNotContact,
        name: 'Could Not Contact',
        shortName: 'Incom. No Con',
    },
];
